import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-attachment-viewer-model',
  template: `<div style="text-align:center;"><img [src]="url" ></div>`,
  styleUrls: ['./attachment-viewer-model.component.scss']
})
export class AttachmentViewerModelComponent implements OnInit {
  @Input() url: string;

  constructor() { }

  ngOnInit() {
  }

}
